import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LaunchIcon from "@mui/icons-material/Launch";
import {
  Button,
  CircularProgress,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useWarpCore } from "modules/bridge/hyperlane/features/tokens/hooks";
import Link from "next/link";

const cellStyle = {
  border: "none",
  paddingY: 3,
  paddingLeft: 0,
  paddingRight: 1,
};

interface Props {
  timestamp: number;
  origin: string;
  originTokenAddressOrDenom?: string;
  destTokenAddressOrDenom?: string;
  amount: string;
  destination: string;
  status: string;
  recipient: string;
  originTxHash?: string;
}

//TODO: move to config after merge
const SCANNERS_BY_ORIGIN = {
  prom: "https://promscan.io/",
  bsc: "https://bscscan.com/",
};

export const HistoryHyperLineItem = ({
  timestamp,
  origin,
  originTokenAddressOrDenom,
  destTokenAddressOrDenom,
  amount,
  destination,
  recipient,
  originTxHash,
  status,
}: Props) => {
  const warpCore = useWarpCore();

  const originToken = warpCore.tokens.find(
    (token) => token.addressOrDenom === originTokenAddressOrDenom
  );

  const destToken = warpCore.tokens.find(
    (token) => token.addressOrDenom === destTokenAddressOrDenom
  );

  return (
    <TableRow>
      <TableCell sx={cellStyle}>
        <Typography>{origin === "prom" ? "Withdraw" : "Deposit"}</Typography>
        <Typography variant="caption" color="textSecondary">
          Time: {new Date(timestamp).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell sx={cellStyle}>
        <Typography variant="body2">
          Token: {amount} {originToken?.symbol}
        </Typography>
        <Link
          href={`${
            SCANNERS_BY_ORIGIN[origin as keyof typeof SCANNERS_BY_ORIGIN]
          }/tx/${originTxHash}`}
          target="_blank"
        >
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{
              alignItems: "center",
              display: "flex",
            }}
          >
            Chain: {origin}
            <IconButton size="small" color="inherit">
              <LaunchIcon fontSize="small" />
            </IconButton>
          </Typography>
        </Link>
      </TableCell>
      <TableCell sx={cellStyle}>
        <Typography variant="body2">
          Token: {amount} {destToken?.symbol}
        </Typography>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            alignItems: "center",
            display: "flex",
          }}
        >
          Chain: {destination}
        </Typography>
      </TableCell>
      <TableCell sx={cellStyle}>
        {status !== "delivered" && status !== "confirmed-transfer" ? (
          originTxHash ? (
            <Button
              href={`${
                SCANNERS_BY_ORIGIN[origin as keyof typeof SCANNERS_BY_ORIGIN]
              }/tx/${originTxHash}`}
              target="_blank"
              sx={{
                width: "92px",
                height: "32px",
              }}
              variant="outlined"
              startIcon={<CircularProgress size={14} />}
            >
              View
            </Button>
          ) : (
            <Typography textAlign="center">{status}</Typography>
          )
        ) : (
          <CheckCircleIcon width={20} height={20} color="success" />
        )}
      </TableCell>
    </TableRow>
  );
};
